// extracted by mini-css-extract-plugin
export var box = "_4p-1";
export var checkboxRow = "_4p-8";
export var checked = "_4p-2";
export var descriptionSpacer = "_4p-a";
export var disabled = "_4p-3";
export var icon = "_4p-6";
export var input = "_4p-0";
export var labelSpacer = "_4p-9";
export var medium = "_4p-5";
export var small = "_4p-4";
export var text = "_4p-7";